<template>
  <v-row align="center" justify="center">
    <v-alert type="error" prominent> 
      The service is currently unavailable. <v-btn depressed class="ml-5" :to="{ name: 'home' }">Try Again!</v-btn></v-alert>
  </v-row>
</template>

<script>
export default {
  name: 'http503',
}
</script>
